import disciplineTypes from "./action-types";
import axios from "axios";
import { showError, showSuccess } from "../../app/toastify";

import commonTypes from "../common/action-types";
import { isSessionExpired } from "../common/actions";

const types = { ...commonTypes, ...disciplineTypes };

export function arrangingCases(data) {
  let tempRes = [...data];

  let temp1 = [];
  let temp2 = [];

  tempRes.forEach((e) => {
    if (e.caseStatusId === 1 && e.currentLetterStatusId === 1)
      temp1.push({ ...e });
    else temp2.push({ ...e });
  });

  return [...temp1, ...temp2];
}
export const getSanctionsWithFaultCategory = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get("/api/discipline/sanctions");

      dispatch({
        type: types.SET_SANCTIONS,
        data,
      });
      dispatch({ type: types.END_LOADING });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getFaultWithSanction = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get("/api/discipline/faults");

      dispatch({
        type: types.SET_FAULTS,
        data,
      });
      dispatch({ type: types.END_LOADING });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getEntitySectorCases = (setLoading, type) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      setLoading(true);
      const { data } = await axios.get(
        "/api/discipline/entity-sector-cases?type=" + type,
      );

      dispatch({
        type: types.SET_ENTITY_SECTOR_CASES,
        data: arrangingCases(data),
      });
      dispatch({ type: types.END_LOADING });
      setLoading(false);
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      setLoading(false);
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const deleteDisciplinaryCase = (caseItem) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      // Make a request to delete the disciplinary case
      await axios.delete(`/api/discipline/entity-sector-cases/${caseItem.id}`);

      // If the deletion is successful, dispatch an action to update the state
      dispatch({
        type: types.DELETE_DISCIPLINARY_CASE,
        caseId: caseItem.id,
      });

      dispatch({ type: types.END_LOADING });

      // Optionally, dispatch a success toast notification
      showSuccess("Disciplinary case deleted successfully");
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getUnitCases = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get("/api/discipline/unit-cases");

      dispatch({
        type: types.SET_UNIT_CASES,
        data,
      });
      dispatch({ type: types.END_LOADING });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const getMyCases = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.get("/api/discipline/my-cases");

      dispatch({
        type: types.SET_MY_CASES,
        data,
      });
      dispatch({ type: types.END_LOADING });
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const getCase = (caseId, setLoading, setShowCaseDetail) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      setLoading(true);
      const { data } = await axios.get("/api/discipline/case/" + caseId);

      dispatch({
        type: types.SET_CASE,
        data,
      });

      setLoading(false);
      setShowCaseDetail(true);
      dispatch({ type: types.END_LOADING });
    } catch (error) {
      setLoading(false);
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const initiateCase = (formData, onClose) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      dispatch({ type: types.START_WAIT });
      const { data } = await axios.post(
        "/api/discipline/initiate-case",
        formData,
      );

      onClose();

      dispatch({
        type: "UPDATE_EMPLOYEE",
        data: data.employee,
      });
      // dispatch({
      //   type: types.SET_CASE,
      //   data: data.request,
      // });
      dispatch({
        type: types.ADD_ENTITY_SECTOR_CASE,
        data: data.request,
      });

      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });
      // if (isFirstCategory) {
      //   setShowCaseDetail(true);
      // }
      showSuccess(
        +formData?.isInitiatedBySupervisor === 1
          ? "Employee Explanation requested and signed"
          : "New discipline case initiated successfully",
      );
      // if (!isFirstCategory) {
      //   history.push("/discipline");
      // }
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      dispatch({ type: types.END_WAIT });
      showError(error);
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
    }
  };
};

export const getCaseAttachments = (caseId, setIsLoading) => {
  return async (dispatch) => {
    try {
      setIsLoading(true);
      const { data } = await axios.get(
        "/api/discipline/case-attachments/" + caseId,
      );

      dispatch({
        type: types.SET_CASE_ATTACHMENTS,
        data,
      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const updateCaseFault = (
  payload,
  caseRequest,
  setShowAddFaultForm,
  setTmpFaults,
) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post(
        "/api/discipline/update-case-faults",
        payload,
      );
      showSuccess("Updated successfully");
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_CASE,
        data: { ...caseRequest, faults: data },
      });
      setTmpFaults([]);
      setShowAddFaultForm(false);
    } catch (error) {
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });

      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const removeCaseFault = (
  payload,
  caseRequest,
  setShowRemoveFaultForm,
) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post(
        "/api/discipline/remove-case-faults",
        payload,
      );
      showSuccess("Removed successfully");
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_CASE,
        data: { ...caseRequest, faults: data },
      });
      setShowRemoveFaultForm(false);
    } catch (error) {
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });

      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const updateCaseDesc = (payload, caseRequest, setShowCaseDescForm) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post(
        "/api/discipline/update-case-description",
        payload,
      );
      showSuccess("Updated successfully");
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_CASE,
        data: { ...caseRequest, request: data },
      });
      setShowCaseDescForm(false);
    } catch (error) {
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });

      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const updateCaseIDCReport = (
  payload,
  caseRequest,
  setShowCaseDescForm,
) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post(
        "/api/discipline/update-case-idc-report",
        payload,
      );
      showSuccess("Updated successfully");
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_CASE,
        data: { ...caseRequest, request: data },
      });
      setShowCaseDescForm(false);
    } catch (error) {
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });

      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const updateCaseAppointingAuthority = (
  { caseId, appointingAuthorityPlanningEntityId },
  caseRequest,
  onClose,
) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });
      const { data } = await axios.post(
        "/api/discipline/update-case-appointing-authority",
        { caseId, appointingAuthorityPlanningEntityId },
      );
      showSuccess("Appointing authority updated successfully");
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });
      // console.log(data, caseRequest);
      dispatch({
        type: types.SET_CASE,
        data: { ...caseRequest, request: data },
      });
      if (typeof onClose === "function") onClose();
    } catch (error) {
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const notifyCaseAppointingAuthority = (
  caseId,
  appointingAuthorityPlanningEntityId,
  caseRequest,
  onClose,
) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });
      const { data } = await axios.post(
        "/api/discipline/notify-case-appointing-authority",
        { caseId, appointingAuthorityPlanningEntityId },
      );
      showSuccess("Sent to the appointing authority successfully");
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });
      if (data) {
        dispatch({
          type: types.SET_CASE,
          data: { ...caseRequest, request: data },
        });
      }
      if (typeof onClose === "function") onClose();
    } catch (error) {
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const updateCaseAttachment = (caseId, payload, onClose) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.put(
        "/api/discipline/case-attachments/" + caseId,
        payload,
      );
      showSuccess("Attachment updated successfully");
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_CASE_ATTACHMENTS,
        data,
      });

      onClose();
    } catch (error) {
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });

      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};
export const addCaseAttachment = (payload, onClose) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_WAIT });
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post(
        "/api/discipline/case-attachments",
        payload,
      );
      showSuccess("Attachment saved successfully");
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });

      dispatch({
        type: types.SET_CASE_ATTACHMENTS,
        data,
      });

      onClose();
    } catch (error) {
      dispatch({ type: types.END_WAIT });
      dispatch({ type: types.END_LOADING });

      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const closeCaseRequest = (caseId, reason, onClose) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.put("/api/discipline/close-case/" + caseId, {
        reason: reason,
      });

      dispatch({
        type: types.UPDATE_DISCIPLINARY_CASE,
        data: data,
      });

      onClose();

      dispatch({ type: types.END_LOADING });
      showSuccess("Case closed successfully");
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};
export const suspendEmployeeProvisionally = (caseId, reason, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.put(
        "/api/discipline/suspend-employee-provisionally/" + caseId,
        { reason: reason },
      );

      dispatch({
        type: "UPDATE_EMPLOYEE",
        data: data.employee,
      });

      dispatch({
        type: types.UPDATE_DISCIPLINARY_CASE,
        data: data.request,
      });
      callback();
      dispatch({ type: types.END_LOADING });
      showSuccess("This action has been completed successfully");
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const updateRequestExplanationLetter = (formData, onClose) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post(
        "/api/discipline/update-request-explanation-letter",
        formData,
      );
      dispatch({
        type: types.SET_CASE,
        data: data,
      });

      onClose();
      dispatch({ type: types.END_LOADING });
      showSuccess("Letter updated successfully");
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const IDCReport = (formData, caseRequest, onClose) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post("/api/discipline/idc-report", formData);
      caseRequest.request = data;

      dispatch({
        type: types.UPDATE_DISCIPLINARY_CASE,
        data: caseRequest.request,
      });

      onClose();

      dispatch({ type: types.END_LOADING });
      showSuccess(`IDC Report submitted successfully`);
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const getDisciplineCaseYearAndMonths = (callback) => {
  return async (dispatch) => {
    callback(true, null);
    try {
      dispatch({ type: types.START_LOADING });
      const { data } = await axios.get("/api/discipline/years-months");

      // dispatch({
      //   type: types.SET_ADMIN_EXIT_YEARS_MONTHS,
      //   data: data,
      // });
      dispatch({ type: types.END_LOADING });
      callback(false, data);
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      callback(false, null);
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};
export const getCaseSanctionNumbers = (
  startDate = "",
  endDate = "",
  entitySectorId = "",
  callback,
) => {
  return async (dispatch) => {
    callback(true, []);
    try {
      // dispatch({ type: types.START_LOADING });
      const { data } = await axios.get(
        "/api/discipline/case-sanction-numbers?startDate=" +
          startDate +
          "&endDate=" +
          endDate +
          "&entitySectorId=" +
          entitySectorId,
      );

      // dispatch({
      //   type: types.SET_ADMIN_EXIT_YEARS_MONTHS,
      //   data: data,
      // });
      // dispatch({ type: types.END_LOADING });
      callback(false, data);
    } catch (error) {
      // dispatch({ type: types.END_LOADING });
      callback(false, []);
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};
//

export const getCaseChartStatistics = (
  startDate = "",
  endDate = "",
  entitySectorId = "",
  callback,
) => {
  return async (dispatch) => {
    callback(true, []);
    try {
      // dispatch({ type: types.START_LOADING });
      const { data } = await axios.get(
        "/api/discipline/case-chart-statistics?startDate=" +
          startDate +
          "&endDate=" +
          endDate +
          "&entitySectorId=" +
          entitySectorId,
      );

      // dispatch({
      //   type: types.SET_ADMIN_EXIT_YEARS_MONTHS,
      //   data: data,
      // });
      // dispatch({ type: types.END_LOADING });
      callback(false, data);
    } catch (error) {
      // dispatch({ type: types.END_LOADING });
      callback(false, []);
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const getCaseSummaryReports = (
  startDate = "",
  endDate = "",
  entitySectorId = "",
  callback,
) => {
  return async (dispatch) => {
    callback(true, []);
    try {
      // dispatch({ type: types.START_LOADING });
      const { data } = await axios.get(
        "/api/discipline/case-summary-reports?startDate=" +
          startDate +
          "&endDate=" +
          endDate +
          "&entitySectorId=" +
          entitySectorId,
      );

      // dispatch({
      //   type: types.SET_ADMIN_EXIT_YEARS_MONTHS,
      //   data: data,
      // });
      // dispatch({ type: types.END_LOADING });
      callback(false, data);
    } catch (error) {
      // dispatch({ type: types.END_LOADING });
      callback(false, []);
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};
export const getDisciplineLetterNo = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(`/api/discipline/letter-no`);

      dispatch({
        type: types.SET_DISCIPLINE_LETTER_NO,
        data,
      });
    } catch (error) {
      // showError(error);
    }
  };
};

///letter-types
export const getHighestFrequencyEmployees = (
  startDate = "",
  endDate = "",
  entitySectorId = "",
  top = 10,
  callback,
) => {
  return async (dispatch) => {
    callback(true, []);
    try {
      // dispatch({ type: types.START_LOADING });
      const { data } = await axios.get(
        "/api/discipline/highest-frequency-employees?startDate=" +
          startDate +
          "&endDate=" +
          endDate +
          "&entitySectorId=" +
          entitySectorId +
          "&top=" +
          top,
      );

      // dispatch({
      //   type: types.SET_ADMIN_EXIT_YEARS_MONTHS,
      //   data: data,
      // });
      // dispatch({ type: types.END_LOADING });
      callback(false, data);
    } catch (error) {
      // dispatch({ type: types.END_LOADING });
      callback(false, []);
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const getCaseApproverLogs = (caseId) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(
        `/api/discipline/case-approver-logs/${caseId}`,
      );

      dispatch({
        type: types.SET_CASE_APPROVER_LOGS,
        data,
      });
    } catch (error) {
      // showError(error);
    }
  };
};
//case-letters
export const getCaseLetters = (caseId, setIsLoading) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: types.SET_CASE_LETTERS,
        data: [],
      });
      setIsLoading(true);
      const { data } = await axios.get(
        `/api/discipline/case-letters/${caseId}`,
      );

      dispatch({
        type: types.SET_CASE_LETTERS,
        data,
      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      // showError(error);
    }
  };
};
export const updateCasePendingLetter = (letterId, formData, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      callback(false);
      const { data } = await axios.put(
        `/api/discipline/case-pending-letter/${letterId}`,
        formData,
      );

      const caseLetters = data;
      dispatch({
        type: types.SET_CASE_LETTERS,
        data: caseLetters,
      });
      // console.log(caseLetters);
      const pendingLetter = caseLetters.find(({ id }) => id === letterId);

      dispatch({
        type: types.SET_CASE_PENDING_LETTER,
        data: pendingLetter,
      });
      showSuccess("Saved successfully");
      callback(true);
      dispatch({ type: types.END_LOADING });
    } catch (error) {
      callback(false);
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const signLetter = (formData, onClose) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.post(
        "/api/discipline/sign-letter",
        formData,
      );

      dispatch({
        type: types.UPDATE_DISCIPLINARY_CASE,
        data: data,
      });
      onClose();

      dispatch({ type: types.END_LOADING });
      showSuccess("Signed & approved successfully");
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const reviewLetter = (
  id,
  formData,
  setShowAddReviewDialog,
  setShowLetter,
) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });

      const { data } = await axios.put(
        "/api/discipline/review-letter/" + id,
        formData,
      );

      dispatch({
        type: types.UPDATE_DISCIPLINARY_CASE,
        data: data.case,
      });

      dispatch({
        type: types.SET_CASE_PENDING_LETTER,
        data: data.pendingLetter,
      });

      dispatch({ type: types.END_LOADING });
      showSuccess("Reviewed successfully");
      setShowAddReviewDialog(false);
      setShowLetter(false);
    } catch (error) {
      dispatch({ type: types.END_LOADING });
      if (isSessionExpired(error)) {
        dispatch({ type: types.SET_REQUIRE_AUTHENTICATION });
      }
      showError(error);
    }
  };
};

export const onInitiateExplanationFeedbackLetter = (
  formData,
  currentCase,
  callback,
) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      callback(true, null);
      const { data } = await axios.post(
        "/api/discipline/initiate-explanation-feedback-letter",
        formData,
      );

      dispatch({
        type: types.UPDATE_DISCIPLINARY_CASE,
        data: data.case,
      });
      currentCase.request = data.case;
      dispatch({
        type: types.SET_CASE,
        data: currentCase,
      });
      const caseLetters = data.caseLetters;
      dispatch({
        type: types.SET_CASE_LETTERS,
        data: caseLetters,
      });
      // console.log(caseLetters);
      const pendingLetter = caseLetters.find(
        ({ letterTypeId, letterStatusId }) =>
          +letterTypeId === 6 && +letterStatusId === 1,
      );

      callback(false, pendingLetter);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      callback(true, null);
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};
export const onInitiateProvisionalSuspensionLetter = (
  formData,
  currentCase,
  callback,
) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      callback(true, null);
      const { data } = await axios.post(
        "/api/discipline/initiate-provisional-suspension-letter",
        formData,
      );

      dispatch({
        type: types.UPDATE_DISCIPLINARY_CASE,
        data: data.case,
      });
      currentCase.request = data.case;
      dispatch({
        type: types.SET_CASE,
        data: currentCase,
      });
      const caseLetters = data.caseLetters;
      dispatch({
        type: types.SET_CASE_LETTERS,
        data: caseLetters,
      });
      // console.log(caseLetters);
      const pendingLetter = caseLetters.find(
        ({ letterTypeId, letterStatusId }) =>
          +letterTypeId === 8 && +letterStatusId === 1,
      );

      callback(false, pendingLetter);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      callback(true, null);
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const onInitiateSanctionLetter = (formData, currentCase, callback) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      callback(true, null);
      const { data } = await axios.post(
        "/api/discipline/initiate-sanction-letter",
        formData,
      );

      currentCase.request = data.case;

      dispatch({
        type: types.SET_CASE,
        data: currentCase,
      });

      dispatch({
        type: types.UPDATE_DISCIPLINARY_CASE,
        data: currentCase.request,
      });

      const caseLetters = data.caseLetters;
      dispatch({
        type: types.SET_CASE_LETTERS,
        data: caseLetters,
      });

      // console.log(caseLetters);
      const pendingLetter = caseLetters.find(
        ({ letterTypeId, letterStatusId }) =>
          [2, 3, 4, 7].includes(+letterTypeId) && +letterStatusId === 1,
      );

      callback(false, pendingLetter);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      callback(true, null);
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const onViewLetter = (letterId, callback) => {
  return async (dispatch) => {
    try {
      callback(true, null);
      const { data } = await axios.get(
        "/api/discipline/view-letter/" + letterId,
      );

      callback(false, data);
    } catch (error) {
      callback(true, null);
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};
